export enum BuiltFilePaths {
  Taskpane = '/taskpane.html',
  Auth = '/Index.html',
  SignInRedirect = '/RedirectTest.html',
  SilentRenew = '/SilentRenew.html',
}

export enum QueryParamKeys {
  Signout = 'signout',
  Window = 'window',
  Formula = 'formula',
  Value = 'value',
  /** Passed to the auth dialog so the IdP can pre-fill the account (OIDC `login_hint`). */
  LoginHint = 'login_hint',
}

export enum QueryParamWindowValues {
  CustomModel = 'customModel',
  TBBreakdownModal = 'TBBreakdownModal',
  InsertTemplate = 'InsertTemplate',
  InsertMFD = 'InsertMFD',
  EngagementSummaryModal = 'EngagementSummaryModal',
  InsertEngagementDetails = 'InsertEngagementDetails',
  InsertEditProcedureOrResponseModal = 'InsertEditProcedureOrResponseModal',
}

export enum LinkedEntityCellTypes {
  SingleEngagementDetails = 'singleEngagementDetails',
  Procedures = 'procedures',
  Responses = 'responses',
}

export enum DialogState {
  DialogReady = 'DIALOG_READY',
}
